import React from 'react';

import { ValueLabelResponse } from 'types';

export type StaticKpiValueCardProps = {
  kpiValues: ValueLabelResponse[];
};

const sliceArrayIntoChunks = (array: ValueLabelResponse[]): ValueLabelResponse[][] => {
  const chunks = [];

  for (let i = 0; i < array.length; i += 3) {
    const chunk = array.slice(i, i + 3);
    chunks.push(chunk);
  }

  return chunks;
};

export const StaticKpiValueCard: React.FC<StaticKpiValueCardProps> = ({ kpiValues }) => {
  const tableRows = sliceArrayIntoChunks(kpiValues);

  return (
    <div className='kpi-values'>
      <table className='kpi-table'>
        <tbody className='kpi-tbody'>
          {tableRows.map((row, i) => (
            <tr className='kpi-tr' key={i}>
              {row.map((kpiValue) => (
                <td className='kpi-td' key={kpiValue.label}>
                  <div className='kpi-value'>
                    <div className='kpi-value-data'>
                      <strong>{kpiValue.value}</strong>
                    </div>
                    <p>{kpiValue.label}</p>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
